function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';
import { PlayIcon } from '@domain-group/fe-co-icon';
import { MultiResolutionBackgroundDiv } from '@domain-group/fe-co-multi-resolution-image';
import * as styles from './parent-development-cover-photo.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
class ParentDevelopmentCoverPhoto extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "onVideoStart", () => {
      this.setState({
        playButtonClicked: true,
        isVisible: 'block'
      });
    });
    _defineProperty(this, "onVideoEnd", () => {
      this.setState({
        playButtonClicked: false,
        isVisible: 'none'
      });
    });
    this.state = {
      playButtonClicked: false,
      isVisible: 'none'
    };
  }
  render() {
    return ___EmotionJSX("div", {
      css: styles.coverPhoto
    }, !this.state.playButtonClicked && ___EmotionJSX("div", null, ___EmotionJSX(MultiResolutionBackgroundDiv, {
      css: styles.heroImage,
      src: this.props.heroImage
    }), this.props.videoUrl && ___EmotionJSX("button", {
      type: "button",
      css: styles.playButton,
      onClick: this.onVideoStart,
      tabIndex: -1,
      "aria-label": "playVideo"
    }, ___EmotionJSX("span", null, ___EmotionJSX(PlayIcon, {
      css: styles.buttonWrapper
    })))), ___EmotionJSX("div", {
      css: styles.videoWrapper,
      style: {
        display: this.state.isVisible
      }
    }, ___EmotionJSX(ReactPlayer, {
      url: this.props.videoUrl,
      playing: this.state.playButtonClicked,
      onEnded: this.onVideoEnd,
      controls: true,
      width: "100%",
      height: "100%"
    })));
  }
}
ParentDevelopmentCoverPhoto.propTypes = {
  heroImage: PropTypes.string,
  videoUrl: PropTypes.string
};
ParentDevelopmentCoverPhoto.defaultProps = {
  heroImage: '',
  videoUrl: ''
};
export default ParentDevelopmentCoverPhoto;